export const CUSTOMER_COOKIE_QUERY = `{
  customer {
    coreInformation {
      gender { value }
      birthDate { value }
    }
    consentInformation {
      focus { value }
    }
  }
}`;
